import { Directive, ElementRef, HostListener, Input, inject } from '@angular/core';
import { LogicService } from '../../service/logic/logic.service';
import { FieldInstance } from '@workflow/class/field.service';

@Directive({
  selector: '[cuFieldState]',
  standalone: true
})
export class FieldStateDirective {
  @Input('cuFieldState') public field: FieldInstance;

  // Using the modern inject pattern
  private el = inject(ElementRef);
  private readonly logicService = inject(LogicService);

  /**
   * Cache state to compare against: value, selectionStart, selectionEnd
   */
  private preChange: string;

  /**
   * Mark field as not focused
   */
  @HostListener('blur')
  public onBlur(): void {
    this.field.focused = false;
    this.logicService.evaluate(this.field.config.onBlur, { field: this.field });
  }

  /**
   * Mark field as focused
   */
  @HostListener('focus')
  public onFocus(): void {
    this.field.focused = true;
    this.logicService.evaluate(this.field.config.onFocus, { field: this.field });
  }

  /**
   * Event that might come with value change
   */
  @HostListener('keydown')
  @HostListener('mousedown')
  public onPrePotentialChange(): void {
    this.preChange = this.el.nativeElement.value;
  }

  /**
   * Event that might be closing value change
   */
  @HostListener('keyup')
  @HostListener('mouseup')
  public onPostPotentialChange(): void {
    if (this.preChange != null && this.preChange !== this.el.nativeElement.value) {
      this.markAsDirty();
    }
    delete this.preChange;
  }

  /**
   * Events with certain user-triggered modifications
   */
  @HostListener('cut')
  @HostListener('input')
  @HostListener('paste')
  public markAsDirty(): void {
    this.field.dirty = true;
  }
}
